/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module NvaccountTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface Nvaccount {
    [k: string]: any;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "ConsentLevel".
 */
export interface ConsentLevel {
    hasRequiredConsent?: boolean;
    hasFunctionalConsent: boolean;
    hasTechnicalConsent?: boolean;
    hasBehavioralConsent: boolean;
}
/**
 * Starfleet id information
 *
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "UserId".
 */
export interface UserId {
    userId: string;
    externalUserId: string;
    identityProviderId: string;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "TokensInformation".
 */
export interface TokensInformation {
    accessToken: string;
    clientToken: string;
    identityToken: string;
    /**
     * Token expiration timestamp as an ISO string
     */
    accessTokenExpiry: string;
    /**
     * Token expiration timestamp as an ISO string
     */
    clientTokenExpiry: string;
    /**
     * Token expiration timestamp as an ISO string
     */
    identityTokenExpiry: string;
    clientTokenValidityDurationMilliseconds: number;
}
/**
 * Contains all available information about the user, except tokens
 *
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "UserAccount".
 */
export interface UserAccount {
    userId: UserId;
    preferredUsername: string;
    consentLevel: ConsentLevel;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "GetEULAAcceptedParameters".
 */
export interface GetEULAAcceptedParameters {
    /**
     * Full EULA text in UTF-8 (No BOM) and Windows line endings (CRLF).
     */
    eulaText: string;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "GetEULAAcceptedReturn".
 */
export interface GetEULAAcceptedReturn {
    isAccepted: boolean;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "SetEULAAcceptedParameters".
 */
export interface SetEULAAcceptedParameters {
    /**
     * Full EULA text in UTF-8 (No BOM) and Windows line endings (CRLF).
     */
    eulaText: string;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "OnLoginParameters".
 */
export interface OnLoginParameters {
    tokens: TokensInformation;
    userAccount: UserAccount;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "GetUserAccountReturn".
 */
export interface GetUserAccountReturn {
    userAccount?: UserAccount1;
}
/**
 * User account information is present only when user is logged in
 */
export interface UserAccount1 {
    userId: UserId;
    preferredUsername: string;
    consentLevel: ConsentLevel;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "GetIdTokenReturn".
 */
export interface GetIdTokenReturn {
    idToken?: string;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "GetUserIdReturn".
 */
export interface GetUserIdReturn {
    userId?: UserId1;
}
/**
 * User id is present only when user is logged in
 */
export interface UserId1 {
    userId: string;
    externalUserId: string;
    identityProviderId: string;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "UserIdChangedNotificationReturn".
 */
export interface UserIdChangedNotificationReturn {
    userId?: UserId2;
}
/**
 * User id is present only when user is logged in
 */
export interface UserId2 {
    userId: string;
    externalUserId: string;
    identityProviderId: string;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "UserConsentChangedNotificationReturn".
 */
export interface UserConsentChangedNotificationReturn {
    userId: UserId;
    consentLevel: ConsentLevel;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "GetPrivacySettingsReturn".
 */
export interface GetPrivacySettingsReturn {
    privacySettings: PrivacySettings;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "SetPrivacySettingsParameters".
 */
export interface SetPrivacySettingsParameters {
    privacySettings: PrivacySettings;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "GetPrivacySettingsConsentInformationReturn".
 */
export interface GetPrivacySettingsConsentInformationReturn {
    deviceConsent: ConsentLevel;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "PrivacySettingsConsentInformationChangedNotificationReturn".
 */
export interface PrivacySettingsConsentInformationChangedNotificationReturn {
    deviceConsent: ConsentLevel;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "PrivacySettingsChangedNotificationReturn".
 */
export interface PrivacySettingsChangedNotificationReturn {
    privacySettings: PrivacySettings;
}
/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "GetUserAccountAndDeviceConsentReturn".
 */
export interface GetUserAccountAndDeviceConsentReturn {
    deviceConsent: ConsentLevel;
    userAccount?: UserAccount2;
}
/**
 * User context will be present only when the user is logged in.
 */
export interface UserAccount2 {
    userId: UserId;
    preferredUsername: string;
    consentLevel: ConsentLevel;
}

/**
 * This interface was referenced by `Nvaccount`'s JSON-Schema
 * via the `definition` "PrivacySettings".
 */
export enum PrivacySettings {
    None = 'None',
    RequiredOnly = 'RequiredOnly',
    RequiredFunctional = 'RequiredFunctional',
    RequiredFunctionalTechnical = 'RequiredFunctionalTechnical'
}


}
